import { ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { AppUser } from "./appUser.ts";

// Adds the authorization header to all graphql requests
export const withAuthMiddleware = (): ApolloLink => {
  return setContext(async (_, { headers }) => {
    const authHeaders = await AppUser.getAuthorizationHeader();
    return {
      headers: {
        ...headers,
        ...authHeaders,
      },
    };
  });
};
